import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { UserEndpoints } from 'src/client/user/constants'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { CustomResponseError } from 'src/config/request'
import { GetUserDataByUcodeResponse } from 'src/client/user/types'
import { UseGetUserDataProps } from './useGetUserData.types'

const useGetUserData = ({ ucode, avatarDimensions, enabled }: UseGetUserDataProps) => {
  const endpoint = UserEndpoints.getUserDataByUcode(ucode)

  const response = useHotRequest<GetUserDataByUcodeResponse, CustomResponseError>(endpoint, {
    cacheKey: [endpoint],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_CONTENT_GATEWAY,
    params: {
      avatarDimensions
    },
    queryOptions: {
      enabled,
      ...DEFAULT_CACHE_CONFIG,
      cacheTime: 1000 * 60 * 10, // 10 minutes
      staleTime: 1000 * 60 * 10 // 10 minutes
    }
  })

  return {
    ...response,
    isLoading: ucode ? response.isLoading : false
  }
}

export default useGetUserData
